// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__SZyn2","label":"Category_label__3l_v6","content":"Category_content__3Z-zK","header":"Category_header__2yn9y","location":"Category_location__3lZjy"};